// extracted by mini-css-extract-plugin
module.exports = {"sliderTitle":"sliderTitle_sliderTitle__1WvOV"};